import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {SUCCESS} from "../../httpClient";
import {fetchAttendanceStatistics, fetchFinanceProjection, fetchFinanceStatistics} from "./statisticsAPI";

const initialState = {
    attendanceStatistics: {labels: [], datasets: []},
    attendanceStatisticsStatus: 'idle',
    financeStatistics: {labels: [], datasets: []},
    financeStatisticsStatus: 'idle',
    financeProjection: {labels: [], datasets: []},
    financeProjectionStatus: 'idle'
}

const statistics = "statistics";

export const fetchAttendanceStatisticsAsync = createAsyncThunk(
    `${statistics}/fetchAttendanceStatistics`,
    async ({token, groupBy}) => {
        return await fetchAttendanceStatistics(token, groupBy);
    }
);

export const fetchFinanceStatisticsAsync = createAsyncThunk(
    `${statistics}/fetchFinanceStatistics`,
    async ({token, groupBy}) => {
        return await fetchFinanceStatistics(token, groupBy);
    }
);

export const fetchFinanceProjectionAsync = createAsyncThunk(
    `${statistics}/fetchFinanceProjection`,
    async (token) => {
        return await fetchFinanceProjection(token);
    }
);


export const statisticsSlice = createSlice({
    name: `${statistics}`,
    initialState,
    reducers: {
        loadAttendanceStatistics: (state,action) => {
            state.attendanceStatistics = action.payload
        },
        loadFinanceStatistics: (state,action) => {
            state.financeStatistics = action.payload
        },
        loadFinanceProjection: (state,action) => {
            state.financeProjection = action.payload
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAttendanceStatisticsAsync.pending, (state) => {
                state.attendanceStatisticsStatus = 'loading';
            })
            .addCase(fetchAttendanceStatisticsAsync.fulfilled, (state, action) => {
                state.attendanceStatisticsStatus = SUCCESS;
                state.attendanceStatistics = action.payload
            })
            .addCase(fetchFinanceStatisticsAsync.pending, (state) => {
                state.financeStatisticsStatus = 'loading';
            })
            .addCase(fetchFinanceStatisticsAsync.fulfilled, (state, action) => {
                state.financeStatisticsStatus = SUCCESS;
                state.financeStatistics = action.payload
            })
            .addCase(fetchFinanceProjectionAsync.pending, (state) => {
                state.financeProjectionStatus = 'loading';
            })
            .addCase(fetchFinanceProjectionAsync.fulfilled, (state, action) => {
                state.financeProjectionStatus = SUCCESS;
                state.financeProjection = action.payload
            })
    }
});

export default statisticsSlice.reducer;
